import { cn } from '../../../lib/utils';
import { Input } from '../../ui/input';

/** A small number box with its unit inside, as on the offer page. */
export function AffixInput({
	value,
	onChange,
	placeholder,
	suffix,
	label,
	disabled = false,
	tone,
	width = 'w-[120px]',
	inputMode = 'decimal',
}: {
	value: string;
	onChange: (value: string) => void;
	placeholder: string;
	suffix: string;
	label: string;
	disabled?: boolean;
	/** `danger` for a value Apply refuses. */
	tone?: 'danger';
	width?: string;
	inputMode?: 'decimal' | 'numeric';
}) {
	return (
		<div className={cn('relative ml-auto', width)}>
			<Input
				inputMode={inputMode}
				value={value}
				onChange={(e) => onChange(e.target.value)}
				placeholder={placeholder}
				aria-label={label}
				aria-invalid={tone === 'danger'}
				disabled={disabled}
				className="h-8 pr-11 text-right font-mono text-sm"
			/>
			<span className="pointer-events-none absolute top-1/2 right-2.5 -translate-y-1/2 text-xs text-text-4">
				{suffix}
			</span>
		</div>
	);
}
